import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import React, { Children } from 'react';
import StickyBox from 'components/StickyBox';
import InlineList from 'components/InlineList';
import { jsx as _jsx } from "react/jsx-runtime";
function StickyButtonPanel(_ref) {
  var children = _ref.children,
    _ref$p = _ref.p,
    p = _ref$p === void 0 ? 'm' : _ref$p,
    _ref$mt = _ref.mt,
    mt = _ref$mt === void 0 ? '-m' : _ref$mt;
  var childrenCount = Children.toArray(children).length;
  return /*#__PURE__*/_jsx(StickyBox, {
    placement: "bottom",
    borderBottomRadius: "inherit",
    textAlign: "center",
    p: p,
    mt: mt,
    children: childrenCount > 1 ? /*#__PURE__*/_jsx(InlineList, {
      spacing: "xs",
      children: children
    }) : children
  });
}
export default StickyButtonPanel;